import { Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
export var TotalSpend = function (totalData) {
    var _a;
    return (React.createElement("div", { "data-testid": "totalSpend", className: "sui-mr-7" },
        React.createElement("div", { className: "sui-flex" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Total Spend:"),
            React.createElement("div", { className: "sui-ml-1" }, totalData === null ? (React.createElement(Typography, { variant: "body-base" }, "----")) : (React.createElement(Typography, { variant: "body-base" },
                "$", (_a = totalData === null || totalData === void 0 ? void 0 : totalData.grossSales) === null || _a === void 0 ? void 0 :
                _a.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
                ' ',
                "in ", totalData === null || totalData === void 0 ? void 0 :
                totalData.year))))));
};
